import Button from 'components/Button';

import s from './Error.module.css';

type TProps = {
  onConfirm?: () => void;
  errorMessage: string;
};

export const Error = ({ errorMessage, onConfirm }: TProps) => {
  const message =
    errorMessage ||
    'There was an error processing your booking. Please try again later.';

  return (
    <div className={s.root}>
      <h1 className={s.title}>Something went wrong.</h1>
      <h2 className={s.subtitle}>Your booking request was unsuccessful.</h2>
      <div>{message}</div>
      {onConfirm && (
        <Button onClick={onConfirm} className={s.doneButton}>
          Okay
        </Button>
      )}
    </div>
  );
};
